var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAssetsPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_assets_pump",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.45,
    height: 48.45,
    viewBox: "0 0 48.45 48.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-pump-3322088",
    d: "M83.359,57.217h-.68V51.765a1.345,1.345,0,0,0-1.345-1.345H74.609V44.36a1.345,1.345,0,0,0,0-2.69h-8.07a1.345,1.345,0,1,0,0,2.69v6.06H59.8a1.345,1.345,0,0,0-1.345,1.345v5.453h-4.7a12.134,12.134,0,0,0-12.12,12.12V84.7a5.395,5.395,0,0,0,5.424,5.424h37.6A5.395,5.395,0,0,0,90.084,84.7V63.87a6.725,6.725,0,0,0-6.725-6.653ZM66.539,53.11h2.69v4.107h-2.69Zm5.38,0h2.69v4.107h-2.69Zm-2.69,21.535A1.345,1.345,0,0,1,70.574,73.3h13.45a1.345,1.345,0,0,1,0,2.69H70.574a1.345,1.345,0,0,1-1.345-1.345Zm14.8-4.035H70.574a1.345,1.345,0,1,1,0-2.69h13.45a1.345,1.345,0,0,1,0,2.69Zm0-8.085h0a1.345,1.345,0,0,1,0,2.69H70.574a1.345,1.345,0,1,1,0-2.69ZM79.99,57.217H77.3V53.11h2.69Zm-18.8-4.035h2.647v4.035h-2.69Zm-7.434,6.653A9.43,9.43,0,1,1,47.086,62.6,9.43,9.43,0,0,1,53.754,59.835ZM48.36,86.143a1.345,1.345,0,1,1,.989-.429,1.345,1.345,0,0,1-.989.429Zm5.394,0A1.345,1.345,0,1,1,55.1,84.8a1.36,1.36,0,0,1-1.345,1.345Zm29.605,0a1.345,1.345,0,1,1,.96-.445,1.345,1.345,0,0,1-.96.445Z",
    transform: "translate(-41.634 -41.67)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssetsPump);
export default __webpack_public_path__ + "static/media/icon_assets_pump.59eb1ad4959810ad17a9ad3e7a984790.svg";
export { ForwardRef as ReactComponent };